import React, { useMemo } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../store/helpers/isLoggedIn';
import SearchParamsHelper from '../../store/helpers/SearchParamsHelper';
import { Ticket } from '../../store/models/Ticket';

/**
 * if not isLoggedIn, will be redirect to the login page
 * @param param0
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();

  const { fromCE, inbox } = useMemo(
    () => SearchParamsHelper.getCEParams(location),
    [location],
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        console.debug(
          `PrivateRoute props: `,
          props,
          'fromCE',
          fromCE,
          'inbox',
          inbox,
        );
        const ticketId = props?.match?.params?.ticketId;
        if (ticketId) {
          Ticket.saveViewingTicketIdToLocalStorage(ticketId);
        } else {
          Ticket.clearViewingTicketIdFromLocalStorage();
        }

        return isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: `/login`,
              search:
                fromCE && inbox
                  ? `?fromCE=true&inbox=${inbox}`
                  : undefined,
              state: {
                from: props.location,
              },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
